import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

/**
 * Hook personnalisé pour récupérer les niveaux d'études
 * Centralise la logique de récupération des niveaux depuis l'API
 */
export const useLevels = () => {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLevels();
  }, []);

  const fetchLevels = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${BACKEND_URL}/api/public/levels`);
      setLevels(response.data || []);
    } catch (err) {
      console.error('Error fetching levels:', err);
      setError('Erreur lors du chargement des niveaux');
      setLevels([]);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Récupère le label d'un niveau par son value
   */
  const getLevelLabel = (levelValue) => {
    const level = levels.find(l => l.level === levelValue);
    return level ? level.label : levelValue;
  };

  /**
   * Récupère la catégorie d'un niveau par son value
   */
  const getLevelCategory = (levelValue) => {
    const level = levels.find(l => l.level === levelValue);
    return level ? level.category : '';
  };

  /**
   * Filtre les niveaux par catégorie
   */
  const getLevelsByCategory = (category) => {
    return levels.filter(l => l.category === category);
  };

  /**
   * Récupère toutes les catégories uniques
   */
  const getCategories = () => {
    const categories = [...new Set(levels.map(l => l.category))];
    return categories.sort();
  };

  return {
    levels,
    loading,
    error,
    refetch: fetchLevels,
    getLevelLabel,
    getLevelCategory,
    getLevelsByCategory,
    getCategories
  };
};

export default useLevels;